import axios from 'axios';
import { apiBaseUrl } from '../config/api_config';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add token to all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('nassar_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Auto-refresh token from response headers
axiosInstance.interceptors.response.use(
  async (response) => {
    // Check if backend sent a refreshed token in response headers
    const refreshedToken = response.headers['x-refreshed-token'];
    if (refreshedToken) {
      localStorage.setItem('nassar_token', refreshedToken);
      console.log('Token auto-refreshed from response headers');
    }
    
    return response;
  },
  async (error) => {
    // If request failed due to authentication error
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Check if error message indicates token expiration
      const errorMessage = error.response?.data?.detail || '';
      const isTokenExpired = errorMessage.includes('expired') || 
                           errorMessage.includes('Invalid token') ||
                           errorMessage.includes('Missing authentication token');
      
      if (isTokenExpired) {
        // Clear token and redirect to login
        localStorage.removeItem('nassar_token');

        // Store session expired message to show on login page
        sessionStorage.setItem('session_expired_message', 'انتهت صلاحية الجلسة. الرجاء تسجيل الدخول مرة أخرى.');
        
        
        // Dispatch custom event to notify app of logout
        window.dispatchEvent(new CustomEvent('auth:logout'));
        
        // Redirect to login page
        window.location.href = '/';

      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;

